// Wraps a real app screenshot (or, via children, an interactive demo standing in for one)
// in the same "browser chrome" styling as the homepage hero's InteractiveVisualizer, so
// every screenshot/demo on the site reads as one consistent visual language rather than a
// bare pasted image.
export default function ScreenshotFrame({ src, alt, label, style, children }) {
  return (
    <div
      className="glass-card"
      style={{
        borderRadius: "var(--radius-lg)",
        overflow: "hidden",
        border: "1px solid var(--border-strong)",
        boxShadow: "var(--shadow-lg)",
        ...style,
      }}
    >
      <div
        style={{
          background: "var(--surface-2)",
          padding: "10px 14px",
          borderBottom: "1px solid var(--border)",
          display: "flex",
          alignItems: "center",
          gap: 10,
        }}
      >
        <div style={{ display: "flex", gap: 6 }}>
          <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#FF5F56", display: "inline-block" }} />
          <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#FFBD2E", display: "inline-block" }} />
          <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#27C93F", display: "inline-block" }} />
        </div>
        {label && (
          <span style={{ fontSize: 12, fontWeight: 600, color: "var(--text-secondary)", margin: "0 auto" }}>{label}</span>
        )}
      </div>
      {children ?? <img src={src} alt={alt} style={{ width: "100%", display: "block" }} />}
    </div>
  );
}
